import { GridValidRowModel } from '@mui/x-data-grid-premium'
import { GridCellParams, GridColDef } from '@mui/x-data-grid-pro'
import React from 'react'
import DataGridCellWrapper from 'src/components/DataGrid/cells/DataGridCellWrapper/DataGridCellWrapper'

import styles from './ApprovalActionsCell.style'

interface ApprovalActionsCellProps<Row extends GridValidRowModel> {
  params: GridCellParams<Row>
  renderCell: (params: GridCellParams<Row>) => React.ReactElement
}

const ApprovalActionsCell = <Row extends GridValidRowModel>(
  props: ApprovalActionsCellProps<Row>,
) => {
  return (
    <DataGridCellWrapper css={styles} params={props.params}>
      {props.renderCell(props.params)}
    </DataGridCellWrapper>
  )
}

export const approvalActionsCellColDef = <Row extends GridValidRowModel>(
  translate: (source: string) => string,
  approvalActions: (params: GridCellParams<Row>) => React.ReactElement,
): GridColDef<Row> => ({
  field: 'approval-actions',
  headerName: translate('Review'),
  resizable: false,
  sortable: false,
  hideable: false,
  minWidth: 145,
  width: 145,
  disableColumnMenu: true,
  cellClassName: 'approval-actions',
  headerClassName: 'approval-actions-header',
  renderCell: (params) => (
    <ApprovalActionsCell params={params} renderCell={approvalActions} />
  ),
})

export default ApprovalActionsCell
